import React from "react";
import s from "./Header.module.scss";
import { CaretDownFilled, GlobalOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { Dropdown, Menu } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";

import { setLang } from "../../redux/ApplicationSlice";
import i18n from "../../i18n";
import { useTranslation } from "react-i18next";

type Props = {};

const LoginHeader = (props: Props) => {
  const dispatch: AppDispatch = useDispatch();
  const lang = useSelector((state: RootState) => state.application.lang);

  const { t } = useTranslation();

  const options4 = (
    <Menu>
      <Menu.Item key='1'></Menu.Item>
      <Menu.Item key='2'>
        <div
          onClick={() => {
            dispatch(setLang("en"));
            changeLang("en");
          }}
          className={s.menu_lang_item}
        >
          <img src='/united-states.png' className={s.flag} />
          EN
        </div>
      </Menu.Item>
      <Menu.Item key='3'>
        <div
          onClick={() => {
            dispatch(setLang("ru"));
            changeLang("ru");
          }}
          className={s.menu_lang_item}
        >
          <img src='/russia (1).png' className={s.flag} />
          RU
        </div>
      </Menu.Item>
    </Menu>
  );

  const changeLang = (lang: "en" | "ru" | "ge") => {
    i18n.changeLanguage(lang);
  };

  return (
    <div className={s.auth_header}>
      <div className={s.auth_header_menu}>
        <Dropdown overlay={options4}>
          <div>
            <GlobalOutlined />
            &nbsp;&nbsp;
            {lang === "en" ? "EN" : "RU"} &nbsp;
            <CaretDownFilled />
          </div>
        </Dropdown>
      </div>
    </div>
  );
};

export default LoginHeader;
